import axios from "axios";
import { ApiKey, liveURL } from "../../const/constants";

const MAIN_URL = `${liveURL}/websiteMain`;
const GET_MAIN_PAGE = `${MAIN_URL}/getMainPage`;

export async function getMainPage() {
  try {
    const response = await axios.get(GET_MAIN_PAGE, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching main page:", error);
    return { Result: false, Msg: error.message };
  }
}
